import React from "react";
import { Routes, Route } from "react-router-dom";
import { ToastProvider } from "../context/toastContext";
import LoginPage from "../pages/auth/login";
import RegisterPage from "../pages/auth/register";
import HomePage from "../pages/publishers/home";
import CampaignsPage from "../pages/publishers/campaigns";
import CampaignDetailPage from "../pages/publishers/campaignDetail";
import ProfilePage from "../pages/publishers/profile";
import SettingsPage from "../pages/publishers/settings";
import GlobalPostbackPage from "../pages/publishers/postback";
import ReportsPage from "../pages/publishers/reports";
import WalletPage from "../pages/publishers/wallet";
import CashbackOffers from "../pages/publishers/cashback-offers";
import AddCashbackOffersPage from "../pages/publishers/add-cashback-offer";
import InvoiceDetailsPage from "../pages/publishers/invoiceDetails";
import AdminHomePage from "../pages/admin/home";
import AdminProfilePage from "../pages/admin/profile";
import AdminPostbackPage from "../pages/admin/postback";
import AdminCampaignsPage from "../pages/admin/campaigns";
import CreateCampPage from "../pages/admin/createcamp";
import AdminReportsPage from "../pages/admin/reports";
import AdminSettingsPage from "../pages/admin/settings";
import AdminPublisherPage from "../pages/admin/publishers";
import AdminInvoicesPage from "../pages/admin/invoice";
import EditCampPage from "../pages/admin/editcamp";
import AdminManagePostbacksPage from "../pages/admin/managepostbacks";
import NotFound from "../pages/public/NotFound";
import AdminRequestsPage from "../pages/admin/requests";
import ForgetPasswordPage from "../pages/auth/forget-password";
import ResetPasswordPage from "../pages/auth/reset-password";
import VerifyEmail from "../pages/auth/VerifyEmail";
import ApprovedCampaignsPage from "../pages/publishers/approved-campaigns";
import PostbackLogsPage from "../pages/publishers/postback-logs";
import AdminApprovedPublisherPage from "../pages/admin/approvedPublishers";
import CampaignLinkTestPage from "../pages/publishers/campaign-link-test";
import { ThemeProvider } from '../context/themeContext';
import ThemeToggle from '../components/ui/themeToggle';

function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <Routes>
          <Route path="/auth/login" exact element={<LoginPage />} />
          <Route path="/auth/register/:mAdminId?" exact element={<RegisterPage />} />
          <Route path="/auth/forget-password" exact element={<ForgetPasswordPage />} />
          <Route path="/auth/verify-email/:token" exact element={<VerifyEmail />} />
          <Route path="/auth/reset-password/:verificationToken" exact element={<ResetPasswordPage />} />
          <Route path="/" exact element={<HomePage />} />
          <Route path="/campaigns" exact element={<CampaignsPage />} />
          <Route path="/approved-campaigns" exact element={<ApprovedCampaignsPage />} />
          <Route
            path="/campaign/:campID"
            exact
            element={<CampaignDetailPage />}
          />
          <Route path="/reports" exact element={<ReportsPage />} />
          <Route path="/cashback-offers" exact element={<CashbackOffers />} />
          <Route
            path="/cashback-offers/create"
            exact
            element={<AddCashbackOffersPage />}
          />
          <Route path="/wallet" exact element={<WalletPage />} />
          <Route
            path="/invoice/:invoiceID"
            exact
            element={<InvoiceDetailsPage />}
          />
          <Route path="/profile" exact element={<ProfilePage />} />
          <Route path="/settings" exact element={<SettingsPage />} />
          <Route path="/global-postback" exact element={<GlobalPostbackPage />} />
          <Route path="/postback-logs" exact element={<PostbackLogsPage />} />
          <Route path="/test-campaign-link" exact element={<CampaignLinkTestPage />} />

          {/* Admin routes here */}
          <Route path="/admin" exact element={<AdminHomePage />} />
          <Route path="/admin/campaigns" exact element={<AdminCampaignsPage />} />
          <Route
            path="/admin/campaigns/create"
            exact
            element={<CreateCampPage />}
          />
          <Route
            path="/admin/campaign/edit/:campID"
            exact
            element={<EditCampPage />}
          />
          <Route path="/admin/reports" exact element={<AdminReportsPage />} />
          <Route
            path="/admin/publishers"
            exact
            element={<AdminPublisherPage />}
          />
          <Route
            path="/admin/approved-publishers"
            exact
            element={<AdminApprovedPublisherPage />}
          />
          <Route path="/admin/invoices" exact element={<AdminInvoicesPage />} />
          <Route path="/admin/manage-postbacks" exact element={<AdminManagePostbacksPage />} />
          <Route path="/admin/requests" exact element={<AdminRequestsPage />} />
          <Route path="/admin/profile" exact element={<AdminProfilePage />} />
          <Route path="/admin/settings" exact element={<AdminSettingsPage />} />
          <Route path="/admin/postback" exact element={<AdminPostbackPage />} />

          {/* 404 Catch-All Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ThemeToggle />
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
